export const FILTER_AFTER = {
  NONE: "none",
  DATE_TIME: "afterDateTime",
  LAST_BUILD: "afterLastBuild",
  IMPORT: "afterImport"
} as const;

export type FilterAfterValue = typeof FILTER_AFTER[keyof typeof FILTER_AFTER];
